module.exports = __webpack_public_path__ + "img/twitter.cb59fc4.svg";